import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { useApi, errMsg, fmtDate } from "@/lib/api";

export const RecapPanel = () => {
  const api = useApi();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api("get", "/admin/recap/preview").then(setD).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const send = async () => {
    if (!window.confirm(`Email the recap for the weekend of ${fmtDate(d.weekend)} to ${d.subscribers} member(s)? Each weekend can only be sent once.`)) return;
    setBusy(true);
    try {
      const r = await api("post", "/admin/recap", {});
      toast[r.status === "sent" ? "success" : "info"](r.status === "sent" ? `Recap sent to ${r.sent} of ${r.subscribers}` : r.status === "skipped" ? "Nothing to send: no published tips with results that weekend" : "That weekend's recap was already sent");
      load();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <section className="rounded-2xl bg-[#131C31] border border-white/5 p-5" data-testid="admin-recap-panel">
      <h2 className="font-display text-lg font-bold mb-1 flex items-center gap-2"><Mail className="w-4 h-4 text-blue-400" />Monday recap email</h2>
      <p className="text-xs text-slate-500 mb-2">Sends automatically every Monday 9am Brisbane time to members who opted in ({d.subscribers}).</p>
      <p className="text-sm text-slate-300 mb-3" data-testid="recap-preview">Weekend of {fmtDate(d.weekend)}: {d.races_resulted} tipped race(s) with results{d.races_resulted ? `, top pick won ${d.top_pick.wins}` : ""}.</p>
      <button data-testid="recap-send-button" onClick={send} disabled={busy || !d.races_resulted} className="px-4 py-1.5 rounded-full bg-white/10 hover:bg-white/20 text-xs disabled:opacity-40">{busy ? "Sending…" : "Send now"}</button>
      {d.log.map((l) => (
        <p key={l.weekend} className="text-xs text-slate-400 py-1 border-t border-white/5 mt-2">{fmtDate(l.weekend)} · {l.state}{l.sent != null ? ` · ${l.sent}/${l.subscribers} sent` : ""}{l.reason ? ` · ${l.reason}` : ""}{l.error ? <span className="block text-rose-300">{l.error}</span> : null}</p>
      ))}
    </section>
  );
};
